import React from "react";
import "./Education.scss";
import EducationCard from "../../components/educationCard/EducationCard";
import {educationInfo} from "../../portfolio";
import { Fade } from "react-reveal";

export default function Education() {
  if (educationInfo.display) {
    return (
      <div className="main" id="education">
        <Fade bottom duration={1000}>
        <h1 className="component-heading">Education</h1>
        </Fade>
        <div className="education-card-container">
          {educationInfo.schools.map((school, index) => (
            <EducationCard key={index} school={school} />
          ))}
        </div>
      </div>
    );
  }
  return null;
}
